import valueIsArrayOfAssertion from './valueIsArrayOfAssertion';
import valueIsString from './valueIsString';

export const valueIsArrayOfString = valueIsArrayOfAssertion(valueIsString);
